import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { historyOperation } from '@utils'
import * as H from 'history'

/**
 * 路由监听
 * @desc 解决首次路由进入时不会触发history.listen
 * @param {RouteComponentProps['history']} history - react-routet-dom的history
 * @param fn - 监听的回调
 */
export const useHistoryListen = (fn: (pathname: string) => void) => {
  const history = useHistory()
  useEffect(() => {
    const pathname = history?.location?.pathname || ''
    fn?.(pathname)
    const unregisterListener = history?.listen?.(({ pathname }) => {
      fn?.(pathname)
    })
    return () => {
      unregisterListener?.()
    }
  }, [])
}

/**
 * 路由的全局拦截
 * @desc 加路由参数用法示例：history.push({
 *                          pathname: '/orders',
 *                          search: '?ordersId=123'
 *                        })
 * @desc 用法和 React Router 的用法保持一致，
 * @desc 并且会在跳转时自动加入b、s、t、ct参数，且去重、合并由search传过来的参数
 */
// const historyList = []

type TReturnType<T extends (...args: any[]) => any> = T extends (...args: any[]) => infer R ? R : never;
type TNewHistory = TReturnType<typeof useHistoryNew>

let baseHistory: TNewHistory
let ionRoute: any
export function setHistoryNew (_history: TNewHistory) {
  baseHistory = _history
}
export function getHistoryNew () {
  return baseHistory
}
export function setIonRoute (_ionRoute: any) {
  ionRoute = _ionRoute
}

export function useHistoryNew () {
  const history = useHistory()
  return {
    ...history,
    push: function (path: string | H.LocationDescriptor, state?: H.LocationState, addSearch?: {[key: string]: string}) {
      historyOperation(history, 'push', path, state, addSearch)
    },
    replace: function (path: string | H.LocationDescriptor, state?: H.LocationState, addSearch?: {[key: string]: string}) {
      historyOperation(history, 'replace', path, state, addSearch)
    },
    hasState: function (path: string) {
      return ionRoute.routeInfo.pathname === path
    },
    getPrevState: function (): string {
      return ionRoute.routeInfo.lastPathname || ''
    },
    getState: function (): string {
      return ionRoute.routeInfo.pathname
    },
    getRouteInfo: function () {
      return ionRoute.routeInfo
    },
    goBack: function (backNumber?: number) {
      const rollback = backNumber ? Math.abs(backNumber) : 1
      if (rollback === 1) {
        history.goBack()
      } else {
        history.go(-rollback)
      }
    }
  }
}
